export default {
  ph_Location: '请选择省、市、区',
  invoice_Location: '收件地址',
  form_bussiness_check: '请上传营业执照',
  form_notice_check: '请上传一般纳税人认定通知书',
  apply_type_normal: '普通发票申请',
  apply_type_vat: '增值税专用发票申请',
  expo_name: '展会名称',
  total_amount: '申请开票金额',
  '元': '元',
  form_taxcode: '纳税人识别号',
  form_taxcode_check: '请输入正确的纳税人识别号',
  form_taxcode_placeholder: '请输入纳税人识别号',
  form_invoice_title: '发票抬头',
  form_invoice_title_check: '请输入发票抬头（可检索）',
  form_apply_person: '发票申请人',
  form_apply_person_check: '请输入发票申请人',
  form_apply_phone: '发票申请联系方式',
  form_apply_phone_check: '请输入正确的手机号码',
  form_apply_phone_placeholder: '请输入发票申请联系方式',
  form_registeraddress: '公司注册地址',
  form_registeraddress_check: '请输入公司注册地址',
  form_company_phone: '公司电话',
  form_company_phone_placeholder: '请输入公司电话',
  form_bank_name: '开户行名称',
  form_bank_name_check: '请输入开户行名称',
  form_bank_num: '银行账号',
  form_bank_num_check: '请输入银行账号',
  click_upload: '上传图片',
  upload_img_fail: '上传图片失败，请重新上传',
  business_license: '营业执照',
  business_license_check: '请上传营业执照',
  taxpayer_notice: '一般纳税人认定通知书',
  'taxpayer_notice_tip': '必须是经国税局认定的增值税一般纳税人方可开具增值税专用发票。请上传相关照片或截图。',
  '查看示例图片': '查看示例图片',
  taxpayer_notice_check: '请上传一般纳税人认定通知书',
  take_type: '领取方式',
  take_type_post: '邮寄',
  take_type_post_tips: '1-2个月邮寄到您所填的地址，邮寄到付，请注意查收',
  take_type_hall_get: '展馆领取',
  take_type_hall_get_tips: '开展期间到服务台领取发票',
  invoice_send_by_email: '邮件领取',
  form_recipient: '收件人',
  form_recipient_check: '请输入收件人',
  form_recipient_phone: '联系电话',
  form_recipient_phone_placeholder: '请输入联系电话',
  form_recipient_address: '详细地址',
  form_recipient_Email:'电子邮件',
  form_recipient_address_check: '填写详细地址',
  form_remarks: '备注',
  form_remarks_placeholder: '（选填）',
  submit_btn: '提交',
  back: '返回',
  '修改': '修改',
  '邮箱': '邮箱',
  '请输入正确的邮箱': '请输入正确的邮箱',
  '请输入邮箱': '请输入邮箱',
  '用于接收电子发票，请填写正确的邮箱': '用于接收电子发票，请填写正确的邮箱',
  '发票申请': '发票申请',
  '发票信息': '发票信息',
  '发票详情': '发票详情',
  '发票领取方式': '发票领取方式',
  '您的发票申请未通过，原因如下：': '您的发票申请未通过，原因如下：',

  '发票类型': '发票类型',
  '查看发票详情': '查看发票详情',
  '普通发票': '普通发票',
  '电子普通发票': '电子普通发票',
  '增值税发票': '增值税发票',
  '增值税专用发票': '增值税专用发票',
  '申请时间': '申请时间',
  '图片附件': '图片附件',
  '开票商品明细': '开票商品明细',
  '审核状态': '审核状态',
  '发票状态': '发票状态',
  '领取方式': '领取方式',
  '总计': '总计',
  '邮寄信息': '邮寄信息',
  '邮件信息': '邮件信息',
  '申请编号': '申请编号',

  'WAITING': '未开票',
  'PENDING': '开票中',
  'PENDING_CHECK': '开票成功签章中',
  'FAILED': '开票失败',
  'FINISH': '已开票',
  'CHECK_FAILED': '开票成功签章失败',
  'PENDING_INVALID': '作废中',
  'VOID_FAIL': '作废失败',
  'INVALID': '已作废',
  'WAIT_CANCEL': '冲红中',
  'CANCELED': '已冲红',
  'CANCEL_FAIL': '冲红失败',

  '请提供正确的一般纳税人通知书': '请提供正确的一般纳税人通知书',
  '申请成功': '申请成功',
  '修改成功': '修改成功'

}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/invoice_apply.js